// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"ReportsNoData-primaryButton-1sagT4","midContainer":"ReportsNoData-midContainer-2N6lqL","noDataContainer":"ReportsNoData-noDataContainer-27PVj2"};